import { LAST_TWELVE_MONTHS, LTM, LTM_EBITDA_ALIAS as LTM_EBITDA, NEXT_TWELVE_MONTHS, NTM, NTM_EBITDA_ALIAS as NTM_EBITDA } from 'common/constants/financials';
import { OptionsForEBITDA } from 'pages/Valuations/approaches/guidelinePublicCompanies/types';
import { FinancialPeriod, GetLtmNtmEBITDAsParams } from './types';

const buildEbitdaOptions = (period: FinancialPeriod | undefined, key: string): OptionsForEBITDA => {
  if (!period?.income_statement) {
    return {};
  }

  const { ebitda, adjusted_ebitda: adjustedEbitda } = period.income_statement;

  return {
    [key]: [
      {
        value: ebitda ?? 0,
        label: `EBITDA: ${ebitda}`,
      },
      {
        value: adjustedEbitda ?? 0,
        label: `Adj EBITDA: ${adjustedEbitda}`,
      },
    ],
  };
};

const findPeriod = (
  financialsPeriods: FinancialPeriod[],
  periodId: number | null | undefined,
  periodType: number
): FinancialPeriod | undefined => {
  if (periodId) {
    const periodById = financialsPeriods.find(p => Number(p.id) === Number(periodId));
    if (periodById) {
      return periodById;
    }
  }

  return financialsPeriods.find(p => p.period_type === periodType);
};

export const resolvePeriodIdFromCellValue = (
  financialsPeriods: FinancialPeriod[],
  cellValue: unknown,
  periodType: number
): number | null => {
  if (cellValue === LAST_TWELVE_MONTHS || cellValue === NEXT_TWELVE_MONTHS) {
    return financialsPeriods.find(p => p.period_type === periodType)?.id ?? null;
  }

  if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
    return Number(cellValue);
  }

  return financialsPeriods.find(p => p.period_type === periodType)?.id ?? null;
};

const getLtmNtmEBITDAs = (
  financialsPeriods: FinancialPeriod[],
  isMultipleColumn = false,
  periodIds?: Pick<GetLtmNtmEBITDAsParams, 'ltmPeriodId' | 'ntmPeriodId'>
) => {
  if (!Array.isArray(financialsPeriods)) {
    return {};
  }

  const ltmKey = isMultipleColumn ? `${LTM_EBITDA}_multiple` : LTM_EBITDA;
  const ntmKey = isMultipleColumn ? `${NTM_EBITDA}_multiple` : NTM_EBITDA;
  const ltmPeriod = findPeriod(financialsPeriods, periodIds?.ltmPeriodId, LTM);
  const ntmPeriod = findPeriod(financialsPeriods, periodIds?.ntmPeriodId, NTM);

  return {
    ...buildEbitdaOptions(ltmPeriod, ltmKey),
    ...buildEbitdaOptions(ntmPeriod, ntmKey),
  };
};

export default getLtmNtmEBITDAs;
